var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_16709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2408 5.7368C14.9046 4.9278 14.2226 4.05432 13.6885 3.77822C14.0694 4.51597 14.3338 5.30825 14.4722 6.1269L14.4736 6.13988C13.5987 3.95868 12.1151 3.07923 10.9034 1.16418C10.8409 1.06656 10.7801 0.967786 10.7212 0.867908C10.6908 0.815732 10.6624 0.762464 10.6359 0.70821C10.5856 0.610894 10.5469 0.508039 10.5205 0.401734C10.5205 0.396823 10.5188 0.392067 10.5155 0.388379C10.5123 0.38469 10.5078 0.382329 10.5029 0.381749C10.4981 0.380563 10.4931 0.380563 10.4884 0.381749C10.4874 0.381749 10.4858 0.383561 10.4845 0.383983C10.4833 0.384406 10.4807 0.386157 10.479 0.386942L10.482 0.381749C8.53841 1.5198 7.8789 3.62649 7.81822 4.68025C7.04205 4.73357 6.29997 5.01958 5.68878 5.50096C5.62503 5.44693 5.55837 5.39642 5.48911 5.34966C5.31276 4.73254 5.30526 4.07941 5.46737 3.4584C4.7536 3.80414 4.11938 4.2943 3.60485 4.89785H3.60123C3.29457 4.50915 3.31613 3.22739 3.3337 2.95962C3.24299 2.99612 3.15639 3.0421 3.07534 3.0968C2.80464 3.29002 2.55155 3.50682 2.31906 3.74465C2.05416 4.01327 1.81221 4.30359 1.59573 4.61257V4.61372V4.61233C1.09834 5.31766 0.74549 6.11448 0.557546 6.95684L0.547222 7.00792C0.518667 7.16847 0.493304 7.32957 0.471146 7.49112C0.471146 7.49692 0.469939 7.50229 0.469335 7.50809C0.401572 7.86012 0.359599 8.21663 0.34375 8.57477V8.61475C0.348942 14.5716 6.80075 18.289 11.957 15.3061C12.9383 14.7383 13.7828 13.9619 14.431 13.0318C15.0791 12.1016 15.5149 11.0404 15.7076 9.92324C15.7206 9.82344 15.7312 9.7246 15.7428 9.62377C15.9021 8.30653 15.7296 6.97035 15.2408 5.7368ZM6.32244 11.7937C6.3586 11.8111 6.39253 11.8299 6.42967 11.8464L6.43504 11.8499C6.39722 11.8317 6.35969 11.813 6.32244 11.7937ZM14.4742 6.14169V6.13426L14.4756 6.14247L14.4742 6.14169Z",
    fill: "url(#paint0_linear_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2408 5.7369C14.9046 4.92791 14.2226 4.05443 13.6885 3.77832C14.0694 4.51607 14.3338 5.30835 14.4722 6.127V6.13437L14.4736 6.14258C15.0699 7.84929 14.9837 9.72044 14.2328 11.365C13.346 13.2679 11.1993 15.2183 7.83918 15.1234C4.20856 15.0206 1.01116 12.3265 0.413425 8.79791C0.304625 8.24147 0.413425 7.95939 0.468127 7.50717C0.393477 7.85841 0.351836 8.21587 0.34375 8.57488V8.61485C0.348942 14.5717 6.80075 18.2891 11.957 15.3062C12.9383 14.7384 13.7828 13.962 14.431 13.0319C15.0791 12.1017 15.5149 11.0405 15.7076 9.92335C15.7206 9.82354 15.7312 9.72471 15.7428 9.62387C15.9021 8.30663 15.7296 6.97045 15.2408 5.7369Z",
    fill: "url(#paint1_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2408 5.7369C14.9046 4.92791 14.2226 4.05443 13.6885 3.77832C14.0694 4.51607 14.3338 5.30835 14.4722 6.127V6.13437L14.4736 6.14258C15.0699 7.84929 14.9837 9.72044 14.2328 11.365C13.346 13.2679 11.1993 15.2183 7.83918 15.1234C4.20856 15.0206 1.01116 12.3265 0.413425 8.79791C0.304625 8.24147 0.413425 7.95939 0.468127 7.50717C0.393477 7.85841 0.351836 8.21587 0.34375 8.57488V8.61485C0.348942 14.5717 6.80075 18.2891 11.957 15.3062C12.9383 14.7384 13.7828 13.962 14.431 13.0319C15.0791 12.1017 15.5149 11.0405 15.7076 9.92335C15.7206 9.82354 15.7312 9.72471 15.7428 9.62387C15.9021 8.30663 15.7296 6.97045 15.2408 5.7369Z",
    fill: "url(#paint2_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4827 6.64647C11.4995 6.65824 11.515 6.67002 11.5308 6.68179C11.3364 6.33715 11.0945 6.0216 10.8121 5.74443C8.40712 3.33906 10.1818 0.528976 10.4811 0.386243L10.484 0.381836C8.54049 1.51989 7.88099 3.62658 7.82031 4.68034C7.91058 4.67412 8 4.66652 8.09225 4.66652C8.78188 4.66779 9.45887 4.85166 10.0544 5.19943C10.6499 5.54721 11.1427 6.04647 11.4827 6.64647Z",
    fill: "url(#paint3_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09359 7.12682C8.08079 7.3193 7.40076 7.98309 7.16299 7.98309C4.96266 7.98309 4.60547 9.31417 4.60547 9.31417C4.70292 10.435 5.48396 11.3582 6.42808 11.8465C6.47119 11.8689 6.51496 11.8891 6.55868 11.9088C6.63351 11.942 6.70927 11.973 6.78588 12.0019C7.10989 12.1165 7.44925 12.182 7.79267 12.1961C11.6493 12.377 12.3964 7.58424 9.61329 6.19345C10.2698 6.108 10.9347 6.26944 11.479 6.64646C11.139 6.04646 10.6462 5.54719 10.0507 5.19942C9.45519 4.85165 8.7782 4.66778 8.08858 4.6665C7.99674 4.6665 7.9069 4.67411 7.81664 4.68033C7.04047 4.73365 6.29838 5.01965 5.68719 5.50104C5.80517 5.6009 5.93836 5.73428 6.21887 6.01075C6.74391 6.52806 8.09057 7.06391 8.09359 7.12682Z",
    fill: "url(#paint4_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09359 7.12682C8.08079 7.3193 7.40076 7.98309 7.16299 7.98309C4.96266 7.98309 4.60547 9.31417 4.60547 9.31417C4.70292 10.435 5.48396 11.3582 6.42808 11.8465C6.47119 11.8689 6.51496 11.8891 6.55868 11.9088C6.63351 11.942 6.70927 11.973 6.78588 12.0019C7.10989 12.1165 7.44925 12.182 7.79267 12.1961C11.6493 12.377 12.3964 7.58424 9.61329 6.19345C10.2698 6.108 10.9347 6.26944 11.479 6.64646C11.139 6.04646 10.6462 5.54719 10.0507 5.19942C9.45519 4.85165 8.7782 4.66778 8.08858 4.6665C7.99674 4.6665 7.9069 4.67411 7.81664 4.68033C7.04047 4.73365 6.29838 5.01965 5.68719 5.50104C5.80517 5.6009 5.93836 5.73428 6.21887 6.01075C6.74391 6.52806 8.09057 7.06391 8.09359 7.12682Z",
    fill: "url(#paint5_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32618 5.24373C5.38009 5.27804 5.43334 5.31339 5.48588 5.34976C5.30954 4.73264 5.30203 4.0795 5.46414 3.4585C4.75035 3.80423 4.11611 4.2944 3.60156 4.89795C3.6393 4.89693 4.76177 4.87676 5.32618 5.24373Z",
    fill: "url(#paint6_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.416462 8.79781C1.01359 12.3264 4.2116 15.0205 7.84221 15.1233C11.2023 15.2183 13.3489 13.2678 14.2358 11.3649C14.9867 9.72034 15.073 7.84918 14.4766 6.14247V6.1351C14.4766 6.12931 14.4754 6.12587 14.4766 6.12768L14.478 6.14066C14.7525 7.9329 13.8409 9.66929 12.4158 10.8434L12.4114 10.8534C9.6347 13.1148 6.97731 12.2178 6.43947 11.8516C6.40163 11.8335 6.36409 11.8148 6.32686 11.7955C4.7079 11.0217 4.0391 9.54667 4.18244 8.2817C3.79813 8.28739 3.42042 8.18149 3.09508 7.97685C2.76974 7.77221 2.51073 7.4776 2.34944 7.12873C2.77443 6.8684 3.259 6.72123 3.75698 6.70124C4.25496 6.68126 4.74976 6.78912 5.19424 7.01456C6.11061 7.43055 7.15336 7.47153 8.09954 7.12873C8.09658 7.06582 6.74993 6.52979 6.22482 6.01272C5.94431 5.73619 5.81118 5.603 5.6932 5.50301C5.62945 5.44896 5.5628 5.39843 5.49353 5.35165C5.44759 5.32031 5.3959 5.28638 5.33384 5.24562C4.76943 4.87865 3.64695 4.89882 3.60982 4.89984H3.60626C3.2996 4.51113 3.32116 3.22938 3.33873 2.96167C3.24802 2.99815 3.16142 3.04411 3.08037 3.09879C2.80966 3.29201 2.55658 3.50881 2.32408 3.74664C2.05823 4.01451 1.81527 4.30416 1.59775 4.61257V4.61372V4.61233C1.10035 5.31766 0.7475 6.11448 0.559556 6.95684C0.555813 6.9726 0.280855 8.17447 0.416462 8.79781Z",
    fill: "url(#paint7_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8088 5.74434C11.0913 6.02182 11.3333 6.33772 11.5276 6.68273C11.5677 6.71261 11.6064 6.74432 11.6435 6.77776C13.3979 8.39491 12.4787 10.6809 12.4102 10.8436C13.8353 9.66948 14.7461 7.93315 14.4724 6.14084C13.5971 3.95868 12.1135 3.07923 10.9019 1.16418C10.8393 1.06656 10.7785 0.967786 10.7196 0.867908C10.6892 0.815732 10.6608 0.762464 10.6343 0.70821C10.5841 0.610894 10.5453 0.508039 10.5189 0.401734C10.5189 0.396823 10.5172 0.392067 10.5139 0.388379C10.5107 0.38469 10.5062 0.382329 10.5013 0.381749C10.4965 0.380563 10.4915 0.380563 10.4868 0.381749C10.4858 0.381749 10.4842 0.383561 10.483 0.383983C10.4818 0.384406 10.4792 0.386157 10.4774 0.386942C10.1781 0.528889 8.40345 3.33897 10.8088 5.74434Z",
    fill: "url(#paint8_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6408 6.77685C11.6036 6.74341 11.5649 6.7117 11.5248 6.68182C11.5091 6.67005 11.4935 6.65827 11.4767 6.6465C10.9324 6.26948 10.2675 6.10804 9.61099 6.19349C12.3941 7.58506 11.6474 12.377 7.79037 12.1961C7.44696 12.182 7.10759 12.1166 6.78358 12.0019C6.70692 11.9732 6.63115 11.9422 6.55638 11.9089C6.5126 11.8889 6.46889 11.869 6.42578 11.8466L6.43116 11.85C6.969 12.2172 9.62554 13.1142 12.4031 10.8517L12.4075 10.8418C12.4767 10.68 13.3959 8.39346 11.6408 6.77685Z",
    fill: "url(#paint9_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60579 9.31402C4.60579 9.31402 4.96298 7.98294 7.16331 7.98294C7.40108 7.98294 8.08171 7.31915 8.09391 7.12667C7.14772 7.46944 6.10497 7.42844 5.18861 7.01243C4.74412 6.78699 4.2493 6.67913 3.75131 6.69913C3.25331 6.71912 2.76874 6.86631 2.34375 7.12667C2.50504 7.47554 2.76405 7.77014 3.08939 7.97479C3.41473 8.17943 3.79244 8.28532 4.17675 8.27963C4.03341 9.54484 4.70221 11.0199 6.32117 11.7935C6.35733 11.8109 6.39127 11.8296 6.4284 11.8462C5.48349 11.358 4.70324 10.4349 4.60579 9.31402Z",
    fill: "url(#paint10_radial_4069_16709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2408 5.7368C14.9046 4.9278 14.2226 4.05432 13.6885 3.77822C14.0694 4.51597 14.3338 5.30825 14.4722 6.1269L14.4736 6.13988C13.5987 3.95868 12.1151 3.07923 10.9034 1.16418C10.8409 1.06656 10.7801 0.967786 10.7212 0.867908C10.6908 0.815732 10.6624 0.762464 10.6359 0.70821C10.5856 0.610894 10.5469 0.508039 10.5205 0.401734C10.5205 0.396823 10.5188 0.392067 10.5155 0.388379C10.5123 0.38469 10.5078 0.382329 10.5029 0.381749C10.4981 0.380563 10.4931 0.380563 10.4884 0.381749C10.4874 0.381749 10.4858 0.383561 10.4845 0.383983C10.4833 0.384406 10.4807 0.386157 10.479 0.386942L10.482 0.381749C8.53841 1.5198 7.8789 3.62649 7.81822 4.68025C7.90849 4.67404 7.99791 4.66643 8.09017 4.66643C8.77979 4.6677 9.45678 4.85158 10.0523 5.19935C10.6478 5.54712 11.1406 6.04639 11.4806 6.64638C10.9363 6.26937 10.2714 6.10792 9.61487 6.19337C12.398 7.58495 11.6513 12.3769 7.79425 12.196C7.45084 12.1819 7.11148 12.1164 6.78746 12.0018C6.71081 11.9731 6.63504 11.9421 6.56026 11.9088C6.51655 11.8888 6.47278 11.8688 6.42967 11.8464L6.43504 11.8499C6.39722 11.8317 6.35969 11.813 6.32244 11.7937C6.3586 11.8111 6.39253 11.8299 6.42967 11.8464C5.48476 11.3581 4.7045 10.4349 4.60706 9.3141C4.60706 9.3141 4.96425 7.98302 7.16458 7.98302C7.40235 7.98302 8.08298 7.31923 8.09518 7.12675C8.09216 7.06383 6.7455 6.5278 6.22046 6.01067C5.93995 5.7342 5.80675 5.60101 5.68878 5.50096C5.62503 5.44693 5.55837 5.39642 5.48911 5.34966C5.31276 4.73254 5.30526 4.07941 5.46737 3.4584C4.7536 3.80414 4.11938 4.2943 3.60485 4.89785H3.60123C3.29457 4.50915 3.31613 3.22739 3.3337 2.95962C3.24299 2.99612 3.15639 3.0421 3.07534 3.0968C2.80464 3.29002 2.55155 3.50682 2.31906 3.74465C2.05416 4.01327 1.81221 4.30359 1.59573 4.61257V4.61372V4.61233C1.09834 5.31766 0.74549 6.11448 0.557546 6.95684L0.547222 7.00792C0.53261 7.07603 0.467342 7.42181 0.457924 7.49607C0.457924 7.49028 0.457924 7.50169 0.457924 7.49607C0.398203 7.85302 0.360076 8.21324 0.34375 8.57477V8.61475C0.348942 14.5716 6.80075 18.289 11.957 15.3061C12.9383 14.7383 13.7828 13.9619 14.431 13.0318C15.0791 12.1016 15.5149 11.0404 15.7076 9.92324C15.7206 9.82344 15.7312 9.7246 15.7428 9.62377C15.9021 8.30653 15.7296 6.97035 15.2408 5.7368Z",
    fill: "url(#paint11_linear_4069_16709)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4069_16709",
    x1: 14.2166,
    y1: 2.8542,
    x2: 1.37133,
    y2: 15.2475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6233 2.15299) scale(16.1311)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.72885 8.74782) scale(16.1311)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67573 -1.50781) scale(11.6863 11.6863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.94299 12.9614) scale(7.68073)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.6112 7.42598) rotate(-13.5915) scale(4.07227 4.76761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.52337 1.49294) scale(5.52551)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8704 -2.01182) scale(23.5748)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.88362 -0.701418) rotate(83.9761) scale(17.2786 11.3398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.39194 3.53956) scale(14.7182 14.7182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4069_16709",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.279 4.40086) scale(16.1089 16.1089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4069_16709",
    x1: 14.0623,
    y1: 2.78791,
    x2: 3.13224,
    y2: 13.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_16709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.265625 0.380615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.e9bef34e88bf8c50a9c1dca5ef9d9cac.svg";
export { ForwardRef as ReactComponent };